"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createInteractionId = void 0;
const web_ui_framework_1 = require("@gruposantander/web-ui-framework");
const INTERACTION_ID_CHARS = '0123456789abcdef';
const INTERACTION_ID_LENGTH = 12;
const createInteractionId = () => (0, web_ui_framework_1.generateHash)(INTERACTION_ID_LENGTH, INTERACTION_ID_CHARS);
exports.createInteractionId = createInteractionId;
//# sourceMappingURL=index.js.map